module.exports = __webpack_public_path__ + "media/images/redesign-images/collabs/canva/canva-01-3f21d9fecdb0460ecb2d2a697de7d22d.jpg";